import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { SheetPage } from '~/features/sheet/sheet-page';

/** `?day=YYYY-MM-DD` opens a past day. No day is today. */
const search = z.object({
  day: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

/** One day of a sheet record (canvas 06-record-sheet): every row of a list, one mark each. */
function SheetRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { day } = Route.useSearch();
  return <SheetPage recordId={recordId} day={day} />;
}

export const Route = createFileRoute('/_app/records/$recordId/sheet')({
  validateSearch: search,
  component: SheetRoute,
});
